import { render } from "./JoinClass.vue?vue&type=template&id=0ef675ae&scoped=true"
import script from "./JoinClass.vue?vue&type=script&lang=js"
export * from "./JoinClass.vue?vue&type=script&lang=js"

import "./JoinClass.vue?vue&type=style&index=0&id=0ef675ae&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef675ae"]])

export default __exports__